module.exports = __webpack_public_path__ + "static/media/history_9.69ae6939.jpg";